import { render } from "./OwnTypePicker.vue?vue&type=template&id=33df7b56&scoped=true"
import script from "./OwnTypePicker.vue?vue&type=script&lang=js"
export * from "./OwnTypePicker.vue?vue&type=script&lang=js"

import "./OwnTypePicker.vue?vue&type=style&index=0&id=33df7b56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33df7b56"]])

export default __exports__